module.exports = __webpack_public_path__ + "static/media/logo-movida.383869c3.png";